exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.outline[data-v-6176cdc5] {\n\tborder: 2px solid black;\n\tpadding:5px;\n}\n.hidetable > tr > td[data-v-6176cdc5] {\n\tborder: none;\n\ttable-layout:fixed;\n\tbackground-color: #ffffff;\n\tborder-collapse: collapse;\n\tempty-cells: show;\n}\n.hideborder > td[data-v-6176cdc5] {\n\t border-top: none;\n\t border-bottom: none;\n}\np[data-v-6176cdc5]{\n\tpadding:0px;\n\tmargin:0px;\n}\n.overlap[data-v-6176cdc5] {\n\tpadding:0px 5px 0px 5px;\n\tfont-size:15px;\n\tfont-weight: bold;\n\tcolor:#000000;\n\tbackground-color:#ffcfcf;\n\tborder-radius: 5px;\n\tborder:2px solid #d62929;\n\tmargin:0px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6176cdc5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/layout_10.vue
// module id = 776
// module chunks = 0